export default __webpack_public_path__ + "static/media/ic_date_range_month.d9e9057e.svg";